class SubscriptionWidget extends HTMLElement {
  connectedCallback() {
    const dataEl = this.querySelector('[data-sw-data]');
    try { this.data = JSON.parse(dataEl.textContent); } catch (e) { this.data = {}; }

    this.input = this.querySelector('[data-sw-input]');
    this.onetimePriceEl = this.querySelector('[data-sw-onetime-price]');
    this.subPriceEl = this.querySelector('[data-sw-sub-price]');
    this.subCompareEl = this.querySelector('[data-sw-sub-compare]');
    this.optOnetime = this.querySelector('.sw-option--onetime');
    this.optSubscribe = this.querySelector('.sw-option--subscribe');

    this.currentVariantId = this.dataset.variantId;
    this.selectedPlanId = this.dataset.defaultPlan;
    this.mode = this.dataset.defaultMode || 'onetime';

    // Mode toggles (clicking either option/radio)
    this.querySelectorAll('[data-sw-mode]').forEach((el) => {
      el.addEventListener('click', () => this.setMode(el.dataset.swMode));
    });
    // Frequency tiles
    this.querySelectorAll('[data-sw-plan-id]').forEach((tile) => {
      tile.addEventListener('click', () => this.selectPlan(tile.dataset.swPlanId));
    });

    // React to the theme's variant change event
    const section = document.getElementById('shopify-section-' + this.dataset.sectionId) || document;
    this.variantSelector = section.querySelector('variant-selects, variant-radios, variant-mixed-inputs');
    if (this.variantSelector) {
      this.variantSelector.addEventListener('on:variant:change', (e) => {
        if (e.detail && e.detail.variant) this.onVariantChange(e.detail.variant);
      });
    }

    this.render();
  }

  setMode(mode) {
    this.mode = mode;
    const radio = this.querySelector('.sw-radio[value="' + mode + '"]');
    if (radio) radio.checked = true;
    this.render();
  }

  selectPlan(planId) {
    this.selectedPlanId = planId;
    if (this.mode !== 'subscribe') { this.setMode('subscribe'); return; }
    this.render();
  }

  onVariantChange(variant) {
    if (!variant) return;
    this.currentVariantId = String(variant.id);
    const vd = this.data[this.currentVariantId];
    // If the selected plan isn't available for this variant, fall back to the first available.
    if (vd && vd.plans && !vd.plans[this.selectedPlanId]) {
      const ids = Object.keys(vd.plans);
      if (ids.length) this.selectedPlanId = ids[0];
    }
    this.render();
  }

  render() {
    const vd = this.data[this.currentVariantId] || {};
    const plan = vd.plans ? vd.plans[this.selectedPlanId] : null;

    if (this.onetimePriceEl && vd.onetime) this.onetimePriceEl.textContent = vd.onetime;
    if (plan) {
      if (this.subPriceEl) this.subPriceEl.textContent = plan.price;
      if (this.subCompareEl) this.subCompareEl.textContent = plan.compare;
    }

    // Active tile highlight
    this.querySelectorAll('[data-sw-plan-id]').forEach((tile) => {
      const isActive = tile.dataset.swPlanId === String(this.selectedPlanId);
      tile.classList.toggle('is-active', isActive);
      tile.setAttribute('aria-pressed', String(isActive));
    });

    // Active option highlight + collapsed/expanded state
    if (this.optOnetime) this.optOnetime.classList.toggle('is-active', this.mode === 'onetime');
    if (this.optSubscribe) this.optSubscribe.classList.toggle('is-active', this.mode === 'subscribe');
    this.dataset.mode = this.mode;

    // Sync the hidden selling_plan input (empty = one-time)
    if (this.input) {
      this.input.value = (this.mode === 'subscribe' && this.selectedPlanId) ? this.selectedPlanId : '';
    }
  }
}

if (!customElements.get('subscription-widget')) {
  customElements.define('subscription-widget', SubscriptionWidget);
}
